<template>
    <div class="platform-intro-container">
        <!-- 顶部导航栏 -->
        <!-- <Top /> -->

        <!-- 页面头部 Banner -->
        <div class="page-banner">
            <div class="banner-overlay"></div>
            <div class="banner-content">
                <h1>平台简介</h1>
                <p>驱动数字孪生，动态资产赋能精准决策</p>
            </div>
        </div>

        <!-- 核心内容区 -->
        <div class="container intro-content">
            <!-- 平台定位 -->
            <section class="intro-section">
                <h2 class="section-title">平台定位</h2>
                <div class="section-body">
                    <p>
                        我们是国内领先的<strong>3D数字资产交易与服务平台</strong>，专注于为数字孪生、工业仿真、智慧城市、元宇宙等领域提供高质量的3D模型资源与全链路服务。
                        我们致力于打通创作者与需求方之间的壁垒，让优质的3D数字资产能够高效流转，赋能产业数字化升级。
                    </p>
                </div>
            </section>

            <!-- 核心价值 -->
            <section class="intro-section">
                <h2 class="section-title">核心价值</h2>
                <div class="value-grid">
                    <div class="value-card">
                        <div class="value-icon">🎯</div>
                        <h3>精准匹配</h3>
                        <p>基于智能算法与标签体系，快速连接模型创作者与行业需求方，提升交易效率</p>
                    </div>
                    <div class="value-card">
                        <div class="value-icon">🛡️</div>
                        <h3>版权保障</h3>
                        <p>专业法务团队与区块链存证技术，为原创模型提供全方位的知识产权保护</p>
                    </div>
                    <div class="value-card">
                        <div class="value-icon">💰</div>
                        <h3>收益共享</h3>
                        <p>零门槛上传，透明分成机制，让创作者获得长期稳定的经济回报</p>
                    </div>
                    <div class="value-card">
                        <div class="value-icon">🚀</div>
                        <h3>生态赋能</h3>
                        <p>提供教程培训、设计大赛、商业合作等多元服务，助力创作者成长与行业发展</p>
                    </div>
                </div>
            </section>

            <!-- 业务场景 -->
            <section class="intro-section">
                <h2 class="section-title">应用场景</h2>
                <div class="scene-list">
                    <div class="scene-item">
                        <h4>🏙️ 数字孪生与智慧城市</h4>
                        <p>为城市管理、交通调度、能源监控等提供高精度建筑、设备、环境模型</p>
                    </div>
                    <div class="scene-item">
                        <h4>🏭 工业仿真与智能制造</h4>
                        <p>覆盖机械、汽车、航空等领域，支持产品设计、虚拟装配、运维培训等场景</p>
                    </div>
                    <div class="scene-item">
                        <h4>🎮 元宇宙与游戏娱乐</h4>
                        <p>提供角色、场景、道具等高质量3D资源，助力元宇宙平台与游戏开发</p>
                    </div>
                    <div class="scene-item">
                        <h4>🏠 建筑与室内设计</h4>
                        <p>丰富的家居、工装、景观模型库，提升设计效率与可视化展示效果</p>
                    </div>
                </div>
            </section>

            <!-- 发展愿景 -->
            <section class="intro-section">
                <h2 class="section-title">发展愿景</h2>
                <div class="section-body">
                    <p>
                        我们致力于成为全球领先的<strong>3D数字资产基础设施服务商</strong>，
                        构建一个开放、透明、可信的数字资产交易生态，让每一份创意都能被看见、被使用、被尊重，
                        共同推动数字经济与实体经济的深度融合。
                    </p>
                </div>
            </section>
        </div>

        <!-- 底部导航 -->
        <!-- <Bottom /> -->
    </div>
</template>

<script>
import Top from '../../components/Header.vue';
import Bottom from '../../components/Footer.vue';

export default {
    name: 'PlatformIntro',
    components: {
        Top,
        Bottom
    }
};
</script>

<style lang="less" scoped>
// 继承全局主题色
@base-deep: #0f1118;
@base-darker: #080a12;
@primary: #0ea5e9;
@primary-light: #38bdf8;
@text-primary: #fff;
@text-secondary: #94a3b8;
@border-color: rgba(148, 163, 184, 0.1);

.platform-intro-container {
    background-color: @base-deep;
    color: @text-primary;
    min-height: 100vh;
}

// 页面Banner
.page-banner {
    position: relative;
    height: 300px;
    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: url('../../assets/banner/2.png') no-repeat 100% 100%;


    .banner-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        opacity: 0.5;
    }

    .banner-content {
        position: relative;
        z-index: 2;
        text-align: center;

        h1 {
            font-size: 2.5rem;
            margin-bottom: 1rem;
            text-shadow: 0 3px 15px rgba(14, 165, 233, 0.4);
        }

        p {
            font-size: 1.2rem;
            color: @text-secondary;
            max-width: 600px;
            margin: 0 auto;
        }
    }
}

// 内容容器
.intro-content {
    padding: 3rem 0;
    max-width: 1200px;
    margin: 0 auto;
}

.intro-section {
    margin-bottom: 4rem;
}

.section-title {
    font-size: 2rem;
    color: @primary-light;
    margin-bottom: 1.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid @primary;
    display: inline-block;
}

.section-body {
    font-size: 1.1rem;
    line-height: 1.8;
    color: @text-secondary;

    p {
        margin-bottom: 1rem;
    }

    strong {
        color: @text-primary;
    }
}

// 核心价值网格
.value-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-top: 2rem;
}

.value-card {
    background-color: @base-darker;
    border: 1px solid @border-color;
    border-radius: 8px;
    padding: 2rem;
    text-align: center;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 20px rgba(14, 165, 233, 0.15);
        border-color: @primary;
    }

    .value-icon {
        font-size: 3rem;
        margin-bottom: 1rem;
    }

    h3 {
        font-size: 1.3rem;
        color: @text-primary;
        margin-bottom: 1rem;
    }

    p {
        color: @text-secondary;
        line-height: 1.6;
    }
}

// 应用场景列表
.scene-list {
    margin-top: 2rem;
}

.scene-item {
    background-color: @base-darker;
    border-left: 4px solid @primary;
    padding: 1.5rem;
    margin-bottom: 1rem;
    border-radius: 0 8px 8px 0;

    h4 {
        font-size: 1.2rem;
        color: @text-primary;
        margin-bottom: 0.5rem;
    }

    p {
        color: @text-secondary;
        line-height: 1.6;
    }
}

// 响应式适配
@media (max-width: 768px) {
    .page-banner {
        height: 200px;

        .banner-content h1 {
            font-size: 1.8rem;
        }

        .banner-content p {
            font-size: 1rem;
        }
    }

    .section-title {
        font-size: 1.5rem;
    }

    .value-grid {
        grid-template-columns: 1fr;
    }
}
</style>